import(/* webpackMode: "eager" */ "E:\\VQBits_Windows\\ManufacturingERP\\webapp\\frontend\\src\\app\\page.tsx");
